export default __webpack_public_path__ + "static/media/saddle_lp_token.9cf43f41.svg";